import { render, staticRenderFns } from "./configure.vue?vue&type=template&id=d39aab4c&scoped=true"
import script from "./configure.vue?vue&type=script&lang=js"
export * from "./configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39aab4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d39aab4c')) {
      api.createRecord('d39aab4c', component.options)
    } else {
      api.reload('d39aab4c', component.options)
    }
    module.hot.accept("./configure.vue?vue&type=template&id=d39aab4c&scoped=true", function () {
      api.rerender('d39aab4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/paidMembers/configure.vue"
export default component.exports